var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02742IconServiceSubnet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bceb60dd-8b8c-4098-94f8-aeb4db2edaef",
    x1: 9.033,
    y1: 10.305,
    x2: 9.033,
    y2: 7.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#6fb02a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#7cc52f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#83d232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86d633"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ac75c21e-2a93-464f-8048-f1518dab8b75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.031,7.7A1.305,1.305,0,1,0,10.338,9,1.305,1.305,0,0,0,9.031,7.7Z",
    fill: "url(#bceb60dd-8b8c-4098-94f8-aeb4db2edaef)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.961,7.374h.888a.284.284,0,0,1,.284.284v6.551a.568.568,0,0,1-.568.568H2.677a0,0,0,0,1,0,0V7.659A.284.284,0,0,1,2.961,7.374Z",
    transform: "translate(13.653 16.485) rotate(134.919)",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.913,3.244H3.8a.284.284,0,0,1,.284.284v7.015a0,0,0,0,1,0,0H3.2a.568.568,0,0,1-.568-.568V3.528a.284.284,0,0,1,.284-.284Z",
    transform: "translate(5.847 -0.358) rotate(44.919)",
    fill: "#1490df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.867,7.374h.888a.568.568,0,0,1,.568.568v6.551a.284.284,0,0,1-.284.284h-.888a.284.284,0,0,1-.284-.284V7.374a0,0,0,0,1,0,0Z",
    transform: "translate(12.132 -7.079) rotate(45.081)",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.483,3.244h.888a0,0,0,0,1,0,0v7.015a.284.284,0,0,1-.284.284H14.2a.284.284,0,0,1-.284-.284V3.812a.568.568,0,0,1,.568-.568Z",
    transform: "translate(29.879 1.435) rotate(135.081)",
    fill: "#1490df"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02742IconServiceSubnet);
export default __webpack_public_path__ + "static/media/02742-icon-service-Subnet.70a22b43e48bd37d9706f5c0e0947659.svg";
export { ForwardRef as ReactComponent };